import {Context} from '@braid/vue-formulate/src/Formulate';

class FormulateCssClassService {
    protected readonly context: Context;
    protected readonly baseClasses: string[];
    protected classes: string[] = [];

    public static classes(context: Context, baseClasses: string[]): string[] {
        const instance = new this(context, baseClasses);

        if(context.type === 'hidden') {
            return [];
        }

        instance.process();

        return instance.appendedClasses();
    }

    public constructor(context: Context, baseClasses: string[]) {
        this.context = context;
        this.baseClasses = baseClasses;
    }

    public process(): void {
        throw new Error('FormulateCssClassService.process() cannot be called directly; use child class');
    }

    protected isGrouped(): boolean {
        return this.context.isGrouped;
    }

    protected hasErrors(): boolean {
        return this.context.hasErrors;
    }

    protected isSelect(): boolean {
        return this.isType('select');
    }

    protected isButton(): boolean {
        return this.isClassification('button');
    }

    protected isText(): boolean {
        return this.isTextarea() || this.isClassification('text')
    }

    protected isSlider() {
        return this.isClassification('slider');
    }

    protected isUpload() {
        return this.isClassification('file');
    }

    protected isClassification(classification: string): boolean {
        return this.context.classification === classification;
    }

    protected isTextInput(): boolean {
        return this.isType('text');
    }

    protected isTextarea(): boolean {
        return this.isType('textarea');
    }

    protected isCheckbox(): boolean {
        return this.isType('checkbox');
    }

    protected isRadio(): boolean {
        return this.isType('radio');
    }

    protected isBox(): boolean {
        return this.isCheckbox() || this.isRadio();
    }

    protected isType(type: string): boolean {
        return this.context.type === type;
    }

    protected addGroupedClass(className: string | string[]): this {
        if (this.isGrouped()) {
            return this.addClass(className);
        }

        return this;
    }

    protected addNonGroupedClass(className: string | string[]): this {
        if (!this.isGrouped()) {
            return this.addClass(className);
        }

        return this;
    }

    protected addClass(className: string | string[]): this {
        if (Array.isArray(className)) {
            className.forEach(cls => this.addClass(cls));
        } else {
            this.classes.push(className)
        }

        return this;
    }

    protected fullwidth() {
        this.addClass('block').addClass('w-full');
    }

    public appendedClasses(): string[] {
        return [
            ...this.baseClasses,
            ...this.classes,
        ]
    }
}

export default FormulateCssClassService;
